import { create } from 'zustand'
import type { Task, LogEntry, TaskStatus } from '@/lib/types'

interface TaskStore {
  tasks: Task[]
  selectedTaskId: string | null
  activeRunId: string | null
  logs: LogEntry[]

  setTasks: (tasks: Task[]) => void
  addTask: (task: Task) => void
  updateTask: (id: string, updates: Partial<Task>) => void
  removeTask: (id: string) => void
  selectTask: (id: string | null) => void
  setActiveRunId: (id: string | null) => void
  addLog: (entry: LogEntry) => void
  clearLogs: () => void
  updateTaskStatus: (id: string, status: TaskStatus) => void
}

export const useTaskStore = create<TaskStore>((set) => ({
  tasks: [],
  selectedTaskId: null,
  activeRunId: null,
  logs: [],

  setTasks: (tasks) => set({ tasks }),
  
  addTask: (task) =>
    set((state) => ({
      tasks: [...state.tasks, task],
    })),

  updateTask: (id, updates) =>
    set((state) => ({
      tasks: state.tasks.map((t) => (t.id === id ? { ...t, ...updates } : t)),
    })),

  removeTask: (id) =>
    set((state) => ({
      tasks: state.tasks.filter((t) => t.id !== id),
      selectedTaskId: state.selectedTaskId === id ? null : state.selectedTaskId,
    })),

  selectTask: (id) => set({ selectedTaskId: id }),
  
  setActiveRunId: (id) => set({ activeRunId: id }),
  
  addLog: (entry) =>
    set((state) => ({
      logs: [entry, ...state.logs].slice(0, 100),
    })),
  
  clearLogs: () => set({ logs: [] }),
  
  updateTaskStatus: (id, status) =>
    set((state) => ({
      tasks: state.tasks.map((t) => (t.id === id ? { ...t, status } : t)),
    })),
}))
